import * as dashboardConstants from './actionTypes';
import request from './Request';
import constants from '../../config/constants';


export const getBusinessCountryDetails = (payload) => {
  return (dispatch) => {
    dispatch({
      type: dashboardConstants.FETCH_COUNTRY_DETAILS
    });
      request({
          method: 'post',
          headers:{
            "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
          },
          url:`${constants.BASE_URL}summary/globalView/country`,   
          data : payload
      })
      .then((response) => {
        dispatch({
          type: dashboardConstants.FETCH_COUNTRY_DETAILS_SUCCESS,
          payload: response?.data || []
        });
      })
      .catch((error) => {
        dispatch({
          type: dashboardConstants.FETCH_COUNTRY_DETAILS_FAILURE,
          payload:error?.response?.data
        });
      })
  }

}
export const getBusinessLocationDetails = (payload) => {
  return (dispatch) => {
    dispatch({
      type: dashboardConstants.FETCH_LOCATION_DETAILS
    });
      request({
          method: 'post',
          headers:{
            "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
          },
          url:`${constants.BASE_URL}summary/globalView/location`,   
          data : payload
      })
      .then((response) => {
        dispatch({
          type: dashboardConstants.FETCH_LOCATION_DETAILS_SUCCESS,
          payload: response?.data || []
        });
      })
      .catch((error) => {
        dispatch({
          type: dashboardConstants.FETCH_LOCATION_DETAILS_FAILURE,
          payload:error?.response?.data
        });
      })
  }

}
export const getBusinessDetails = (payload) => {
  return (dispatch) => {
    dispatch({
      type: dashboardConstants.FETCH_BUSINESS_DETAILS
    });
      request({
          method: 'post',
          headers:{
            "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
          },
          url:`${constants.BASE_URL}summary/globalView/business`,   
          data : payload,
      })
      .then((response) => {
        dispatch({
          type: dashboardConstants.FETCH_BUSINESS_DETAILS_SUCCESS,
          payload: response?.data || []
        });
      })
      .catch((error) => {
        dispatch({
          type: dashboardConstants.FETCH_BUSINESS_DETAILS_FAILURE,
          payload:error?.response?.data
        });
      })
  }

}

export const getYearList = (payload) => {
const userDetails = JSON.parse(window.localStorage.getItem("userInfo"));

  return (dispatch) => {
      request({
          method: 'get',
          headers:{
            "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
          },
          url:`${constants.BASE_URL}lov/year/${userDetails?.userId}`,   
          data : payload,
      })
      .then((response) => {
        dispatch({
          type: dashboardConstants.FETCH_YEAR_SUCCESS,
          payload: response?.data || []
        });
      })
      .catch((error) => {
        dispatch({
          type: dashboardConstants.FETCH_YEAR_FAILURE,
          payload:error?.response?.data
        });
      })
  }

}


